import { useReduxState } from 'hooks';

interface Props {
  title?: string;
}

const DropdownDivider = ({ title }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="divider">
      <div className="divider-inner" />

      {title ? <div className="divider-title">{title}</div> : null}

      <style jsx>{`
        .divider {
          margin: 8px 0;
          width: 100%;
        }
        .divider-inner {
          background-color: ${theme.lightGrey};
          height: 1px;
          margin: 0 -5px;
        }
        .divider-title {
          color: ${theme.textColorLighter};
          font-size: 1.1rem;
          font-weight: 600;
          padding: 12px 12px 0px;
          text-transform: uppercase;
        }
      `}</style>
    </div>
  );
};

export default DropdownDivider;
